import * as React from 'react';
import moment from 'moment';

import DatePickerMulti from 'components/date-picker/date-picker-multi/DatePickerMultiLazy';

import SOVFiltersSectionHeader from '../section/SOVFiltersSectionHeader';

import { __t, applyTranslations } from 'utils/language';
import { HTML_DATE_FORMAT } from 'utils/date';

import './sov-filters-timeframe.scss';

applyTranslations(require('../sov-filters.i18n.json'));

type Props = {
  startDate: string | undefined | null,
  endDate: string | undefined | null,
  withErrorHighlight?: boolean,
  limitSelectableDates: boolean,
  onTimeframeChange: (b?: string | null, a?: string | null) => void
};

const FILTERS_MSG_KEY = 'sov_filters';

class SOVFiltersTimeframe extends React.PureComponent<Props> {
  renderCalendarInfo(): React.ReactNode {
    return (
      <div className="sov-filters-timeframe__calendar-info">
        {__t(`${FILTERS_MSG_KEY}.messages.timeframe_availability`)}
      </div>
    );
  }

  renderDatePicker(): React.ReactNode {
    const { startDate, endDate, limitSelectableDates, onTimeframeChange } = this.props;

    const dateLimit = !limitSelectableDates
      ? moment().subtract(5, 'd').format(HTML_DATE_FORMAT)
      : null;

    return (
      <DatePickerMulti
        startDateName="startDate"
        startDate={startDate}
        endDateName="endDate"
        endDate={endDate}
        noPastDates={false}
        numMonths={1}
        maxAllowableDate={dateLimit}
        minAllowableDate="2018-01-01"
        calendarInfo={this.renderCalendarInfo()}
        onChange={onTimeframeChange}
        noFutureDates
        showDateSelector
      />
    );
  }

  renderHeader(): React.ReactNode {
    return (
      <SOVFiltersSectionHeader
        msgKey="timeframe"
        tooltipKey="timeframe"
        isRequired
      />
    );
  }

  render(): React.ReactNode {
    const { startDate, endDate, withErrorHighlight } = this.props;
    const isEmptyTimeFrame = Boolean(!startDate || !endDate);
    const isInvalidTimeFrame = startDate && moment(startDate).isBefore('2018-01-01');

    return (
      <div className="sov-filters-timeframe">
        {this.renderHeader()}
        {this.renderDatePicker()}
        {withErrorHighlight && isEmptyTimeFrame && (
          <div className="form-field__error">
            {__t(`${FILTERS_MSG_KEY}.errors.missed_timeframe_error`)}
          </div>
        )}
        {withErrorHighlight && isInvalidTimeFrame && (
          <div className="form-field__error">
            {__t(`${FILTERS_MSG_KEY}.errors.incorrect_timeframe_error`)}
          </div>
        )}
      </div>
    );
  }
}

export default SOVFiltersTimeframe;
